/*eslint-disable*/

import React, { useEffect, useState } from "react";
import axios from "axios";
import { TextField, InputAdornment } from "@mui/material";
import { HiSearch } from "react-icons/hi"; // Example icon

interface LocationSearchProps {
    onAddressSelect: (
        street: string,
        city: string,
        zipCode: string,
        lat: string,
        long: string
    ) => void;
}

const LocationSearch: React.FC<LocationSearchProps> = ({ onAddressSelect }) => {
    const [query, setQuery] = useState("");
    const [selectPlace, setSelectPlace] = useState(null);
    const [filteredPlaces, setFilteredPlaces] = useState([]);
    const [showSuggestions, setShowSuggestions] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const [error, setError] = useState(null);

    // Fetch data with proper URL encoding
    const findPlace = async () => {
        setIsLoading(true);
        setError(null);

        try {
            const encodedQuery = encodeURIComponent(query);
            const apiUrl = `https://data.geopf.fr/geocodage/completion/?text=${encodedQuery}&terr=METROPOLE&maximumResponses=10`;

            const response = await axios.get(apiUrl);
            setFilteredPlaces(response.data.results || []);
        } catch (err) {
            console.error("Error fetching location data:", err);
            setError(
                "Impossible de récupérer les adresses. Veuillez réessayer."
            );
            setFilteredPlaces([]);
        } finally {
            setIsLoading(false);
        }
    };

    // Select a place and send its data to parent
    const handleSelect = (place: any) => {
        setSelectPlace(place);
        setQuery(place.fulltext);
        setFilteredPlaces([]);
        setShowSuggestions(false);
        console.log("place", place);

        // Extracting address, city, and zip code from the selected place
        // Assuming you have a place object with fulltext
        const street = place.fulltext ? place.fulltext.split(",")[0] : "";
        const city = place.city || "";
        const zipCode = place.zipcode || "";
        const lat = place.x || "";
        const long = place.y || "";

        // Call parent function to pass the selected values
        onAddressSelect(street, city, zipCode, lat, long);
    };

    useEffect(() => {
        if (query.length < 3) {
            setFilteredPlaces([]);
            setShowSuggestions(false);
            if (query.length === 0) {
                setSelectPlace(null);
            }
        } else {
            setShowSuggestions(true);
            findPlace();
        }
    }, [query]);

    useEffect(() => {
        if (selectPlace) {
            setFilteredPlaces([]);
            setShowSuggestions(false);
        }
    }, [selectPlace]);

    return (
        <div className="relative">
            <TextField
                variant="standard"
                type="text"
                value={query}
                name="address_1"
                onChange={(e) => setQuery(e.target.value)}
                label="Rechercher une adresse"
                fullWidth
                onFocus={() => {
                    if (query.length >= 3) setShowSuggestions(true);
                }}
                onBlur={() => {
                    setTimeout(() => setShowSuggestions(false), 200);
                }}
                InputProps={{
                    startAdornment: (
                        <InputAdornment position="start">
                            <HiSearch size={20} color="gray" />
                        </InputAdornment>
                    ),
                }}
            />

            {isLoading && (
                <div className="absolute top-full w-full bg-white border border-slate-300 rounded-lg shadow-lg p-3 z-10">
                    Chargement des adresses...
                </div>
            )}

            {error && (
                <div className="absolute top-full w-full bg-white border border-red-300 rounded-lg shadow-lg p-3 text-red-500 z-10">
                    {error}
                </div>
            )}

            {showSuggestions && filteredPlaces.length > 0 && (
                <div className="absolute top-full w-full bg-white border border-slate-300 rounded-lg shadow-lg max-h-60 overflow-y-auto no-scrollbar z-10 text-left">
                    {filteredPlaces.map((place) => (
                        <div
                            key={place.id}
                            onMouseDown={(e) => {
                                e.preventDefault();
                                handleSelect(place);
                            }}
                            className="cursor-pointer px-3 py-2 hover:bg-gray-100"
                        >
                            <div className="flex flex-row items-center h-full">
                                {place.fulltext}
                            </div>
                        </div>
                    ))}
                </div>
            )}

            {showSuggestions &&
                query.length >= 3 &&
                filteredPlaces.length === 0 &&
                !isLoading &&
                !error && (
                    <div className="absolute top-full w-full bg-white border border-slate-300 rounded-lg shadow-lg p-3 z-10">
                        Aucune adresse trouvée
                    </div>
                )}
        </div>
    );
};

export default LocationSearch;
